export const convenios = [
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "SEGUNDO Convenio Modificatorio al Convenio Específico de Coordinación en materia de transferencia de insumos y ministración de recursos presupuestarios federales para realizar acciones en materia de salud pública en las entidades federativas, que celebran la Secretaría de Salud y el Estado de Hidalgo (02-CM-SaNAS-HGO/2026)",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/04092026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO Específico en Materia de Transferencia de Recursos Federales (CEMTR), con carácter de subsidios, para fortalecer la Ejecución y Desarrollo de los Programas y Proyectos Federales de Protección contra Riesgos Sanitarios, así como de la Red Nacional de Laboratorios, correspondiente al Ejercicio Fiscal 2026. (COFEPRIS-CETR-HGO-13-26)",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/COFEPRIS-CETR-HGO-13-26.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO Específico de Coordinación para la transferencia de los bienes inmuebles relacionados con los establecimientos de salud a que se refiere la cláusula segunda y Anexo 1 del Convenio de Coordinación que establece la forma de colaboración en materia de personal, infraestructura, equipamiento, medicamentos y demás insumos asociados para la prestación gratuita de servicios de salud, para las personas sin seguridad social, que celebran Servicios de Salud del Instituto Mexicano del Seguro Social para el Bienestar (IMSS-BIENESTAR) y el Estado de Hidalgo.",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Convenio para la Transferencia de Bienes Inmuebles 27092024.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "SEGUNDO Convenio Modificatorio al Convenio de Coordinación que establece la forma de colaboración en materia de personal, infraestructura, equipamiento, medicamentos y demás insumos asociados para la prestación gratuita de servicios de salud, para las personas sin seguridad social, que celebran la Secretaría de Salud, el Instituto Mexicano del Seguro Social, Servicios de Salud del Instituto Mexicano del Seguro Social para el Bienestar (IMSS-BIENESTAR) y el Estado de Hidalgo.",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/SEGUNDO Convenio Modificatorio al Convenio de Coordinacion que establece la forma de colaboracion 27082024.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio Específico de transferencia de recursos presupuestarios federales con el carácter de subsidios, para realizar acciones en materia de prevención, atención y control de la salud mental y adicciones CRESCA 2026",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Convenio-CRESCA-2026.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio de Colaboración para la Prestación de Servicios de Salud a Menores de 18 años sin Seguridad Social 2026",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Convenio Colaboracion Menores de 18 sin Seguridad Social 2026.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "TERCER Convenio Modificatorio al Convenio de Coordinación que establece la forma de colaboración en materia de personal, infraestructura, equipamiento, medicamentos y demás insumos asociados para la prestación gratuita de servicios de salud, para las personas sin seguridad social en el Estado de Hidalgo, de fecha 11 de Agosto de 2023.",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/27012026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: 03-CM-SaNAS-HGO/2025",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO-03-CM-SaNAS-HGO-2025.pdf"
            }
         ]
    },     
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "1er. Convenio Modificatorio SaNAS 2026",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO-01-CM-SaNAS-HGO-2026.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "1er. Informe Trimestral de indicadores SANAS 2026",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Indicadores SaNAS 1er Trimestre 2026.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "4to. Informe Trimestral de indicadores SANAS 2025",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Indicadores SaNAS 4to Trimestre 2025.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: SaNAS 2026",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO-SaNAS-HGO-2026.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo de Coordinación para la Transferencia de Recursos Presupuestarios para Garantizar la Prestación Gratuita de Servicios de Salud, Medicamentos y demás Insumos Asociados para las Personas sin Seguridad Social, en los términos previstos en el Título Tercero Bis de la Ley General de Salud, con cargo a los recursos del Programa Presupuestario U013 \"Atención a la Salud y Medicamentos Gratuitos para la Población sin Seguridad Social Laboral\" para el ejercicio fiscal 2026",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Acuerdo U013 2026.pdf"
            }
         ]
    }, 
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo de Coordinación para la Transferencia de Recursos Presupuestarios para Garantizar la Prestación Gratuita de Servicios de Salud, Medicamentos y demás Insumos Asociados para las Personas sin Seguridad Social con cargo a los recursos del Programa Presupuestario U013 \"Atención a la Salud y Medicamentos Gratuitos para la Población sin Seguridad Social Laboral\" para el ejercicio fiscal 2025",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Acuerdo U013 2025.pdf"
            }
         ]
    }, 
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "3er. Informe Trimestral Indicadores SANAS 2025 Vigilancia por Laboratorio",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/3er Trim de Indicadores SaNAS 2025 Vig Lab.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "2do. Informe Trimestral Indicadores SANAS 2025 Vigilancia por Laboratorio",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/2do Trim de Indicadores SaNAS 2025 Vig Lab.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "1er. Informe Trimestral Indicadores SANAS 2025 Vigilancia por Laboratorio",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/1er Trim de Indicadores SaNAS 2025 Vig Lab.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "3er. Informe Trimestral de indicadores SANAS 2025",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Indicadores SaNAS 3er Trimestre 2025.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "2do. Informe Trimestral de indicadores SANAS 2025",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Indicadores SaNAS 2do Trimestre 2025.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio de Colaboración para la Prestación de Servicios de Salud a Menores de 18 años sin Seguridad Social 2025",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Convenio Colaboracion Menores de 18 sin Seguridad Social.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: 02-CM-SaNAS-HGO/2025",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO-02-CM-SaNAS-HGO-2025.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: IB-CC-S200-FAM-2025-HGO-13",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Convenio-S200-Hidalgo-2025.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: 01-CM-SaNAS-HGO/2025",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO-01-CM-SaNAS-HGO-2025.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio específico en materia de transferencia de recursos presupuestarios federales con el carácter de subsidios para realizar acciones en materia de prevención y control de la salud mental y adicciones.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO ESPECIFICO CRESCA E025-CONASAMA-HIDALGO-001/2025",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO-ESPECÍFICO-CRESCA-E025-CONASAMA-HIDALGO-001-2025.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: SaNAS-HGO-2025",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO-SaNAS-HGO-2025.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: 01-CM-SaNAS-HGO-2024",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO-01-CM-SaNAS-HGO-2024.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: 02-CM-SaNAS-HGO-2024",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO-02-CM-SaNAS-HGO-2024.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Indicadores SaNAS 4to Trimestre 2024 Vigilancia por Laboratorio",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/4to Trim de Indicadores SaNAS 2024 Vig Lab.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Indicadores SaNAS 3er Trimestre 2024 Vigilancia por Laboratorio",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/3er Trim de Indicadores SaNAS 2024 Vig Lab.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Indicadores SaNAS 2do Trimestre 2024 Vigilancia por Laboratorio",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/2do Trim de Indicadores SaNAS 2024 Vig Lab.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Indicadores SaNAS 1er Trimestre 2025",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Indicadores SaNAS 1er Trimestre 2025.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Indicadores SaNAS 4to Trimestre 2024",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Indicadores SaNAS 4to Trimestre 2024.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Indicadores SaNAS 3er Trimestre 2024",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Indicadores SaNAS 3er Trimestre 2024.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: IB-CC-S200-FAM-2024-HGO-13",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO FAM 2024.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: PO-U013-SN-2024-HIDALGO-13",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO PO-U013-SN-2024-HIDALGO-13.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: PO-E001-SN-2024-HIDALGO-13",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO PO-E001-SN-2024-HIDALGO-13.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: PO-E001-SN-2023-HIDALGO-13",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO PO-E001-SN-2023-HIDALGO-13.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Indicadores SaNAS 2do Trimestre 2024",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Indicadores SaNAS 2do Trimestre 2024.zip"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO ESPECIFICO CRESCA-CONASAMA-E025-HGO-001/2024",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/HIDALGO CONVENIO ESPECIFICO CRESCA 2024.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO-SaNAS-HGO/2024",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO-SaNAS-HGO-2024.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "IMSS-BIENESTAR PRESTACIÓN GRATUITA DE SERVICIOS DE SALUD, MEDICAMENTOS Y DEMÁS INSUMOS ASOCIADOS 2024",
                "transparencia_item_url" : "./ImssBienestar/ImssBienestar"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: CC-E001-2024-HID-15",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO CC-E001-2024-HID-15.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO: PM-E023-2023-HIDALGO-13",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO PM-E023-2023-HIDALGO-13.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Indicadores 2023 SaNAS",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Indicadores 2023 SaNAS.zip"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Informe Trimestral 2022 AFASPE",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Informe Trimestral 2022 AFASPE.zip"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Indicadores 2022 AFASPE",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Indicadores 2022 AFASPE.zip"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO-SaNAS-HGO/2023",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Convenio SaNAS 2023.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio INSABI-APS-E023-2023-HGO-13",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/INSABI -APS-E023-2023-HGO-13.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio INSABI-FAM-CCO-HGO-13/2023",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/INSABI-FAM-CCO-HGO-13-2023.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio específico de transferencia de recursos presupuestarios federales con el carácter de subsidios para realizar acciones en materia de prevención, atención y tratamiento de las adicciones.",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO ESPECÍFICO CRESCA-CONADIC-HGO-001-2023.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "INSABI Prestación gratuita de servicios de salud, medicamentos y demás insumos asociados 2023 - Acuerdo de coordinación Anexo 4",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/INSABI 2023 - Acuerdo de Coordinación - Anexo 4.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "INSABI Prestación gratuita de servicios de salud, medicamentos y demás insumos asociados 2023 - Acuerdo de coordinación 2023",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Acuerdo de Coordinación 2023-2028.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "INSABI Prestación gratuita de servicios de salud, medicamentos y demás insumos asociados 2023",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/ANEXO 6 CAF- CAE Partidas 2023.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "INSABI Prestación gratuitas de servicios de salud, medicamentos y demás insumos asociados 2022 - Acuerdo de coordinación - Anexo 4",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/ANEXO 4 - Monto de Recursos a Transferir y Conceptos de Gasto 2022.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "INSABI-APS-E023-2022-HGO-13",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Copia Certificada Convenio de Colaboración Programa Presupuestario E023.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "INSABI Prestación gratuita de servicios de salud, medicamentos y demás insumos asociados 2022.",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/1. Anexo 6CAF - CAE Partidas 2022 - Actualización al 17-mayo-2022.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio Específico en Materia de Transferencia de Recursos Federales con el Carácter de Subsidios para Fortalecer la Ejecución y el Desarrollo del Programa y Proyectos de Protección Contra Riesgos Sanitarios asi como la Red NAcional de Laboratorios COFEPRIS-CERT-HGO-13-22, COFEPRIS-CERT-HGO-13-22",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO HIDALGO 2022.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Programa regularización y vigilancia de establecimientos y servicios de atención médica G005.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio especifico de colaboración No. DGCES-CETR-HGO-G005-2022 en materia de transferencia de recursos presupuestarios federales con el carácter de subsidios",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Covenio HIDALGO G005 2022 firmado.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Primer Modificatorio Convenio AFASPE 2022",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/01-CM-AFASPE-HGO-2022.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Segundo Modificatorio Convenio AFASPE 2022",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/02-CM-AFASPE-HGO-2022.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "INSABI-FAM-CCTR-HGO-13/2022",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO FAM.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "COFEPRIS-CETR-HGO-13-22",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO COFEPRIS-CETR-HGO-13-2022.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio CRESCA-CONADIC-HGO-001/2022",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO-CRESCA-CONADIC-HGO-001-2022.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "INSABI Prestación gratuita de servicios de salud, medicamentos y demás insumos asociados 2022.",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/1. Anexo Partidas Autorizadas 2022 - Actualizacion al 27-abril-2022.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio AFASPE 2022",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio AFASPE 2022",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO AFASPE 2022 FIRMADO.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "INSABI Prestación gratuita de servicios de salud, medicamentos y demás insumos asociados 2021.",
                "transparencia_item_url" : "./Insabiconv/Insabiconv"
            }
         ]
    },
    {
        "tramite_loc" : "Atención a la salud para el ejercicio fiscal 2021.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio de colaboración en materia de transferencia de recursos presupuestarios federales con el carácter de subsidios para el desarrollo de acciones correspondientes al programa presupuestario E023",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO PSP-E023-2021-HGO-13.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio Específico en Materia de Ministración de Subsidios para el Fortalecimiento de Acciones de Salud Pública de las Entidades Federativas.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Primer Modificatorio Convenio AFASPE 2021",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/01-CM-AFASPE-HGO-2021 FIRMADO.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio Específico en Materia de Ministración de Subsidios para el Fortalecimiento de Acciones de Salud Pública de las Entidades Federativas.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Segundo Modificatorio Convenio AFASPE 2021",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/02-CM-AFASPE-HGO-2021 FIRMADO.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Programa regularización y vigilancia de establecimientos y servicios de atención médica G005.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio especifico de colaboración No. DGCES-CETR-HGO-G005-2021 en materia de transferencia de recursos presupuestarios federales con el carácter de subsidios",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO_HGO_G005_2021.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Primer Trimestre",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Partidas y monto del Programa de Gasto 2021 Inicial",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/1. Partidas y monto del Programa de Gasto 2021 Inicial PRIMER TRIMESTRE.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Segundo Trimestre",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Partidas y monto del Programa de Gasto 2021 Modificado",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/2. Partidas y monto del Programa de Gasto 2021 Modificado SEGUNDO TRIMESTRE.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio AFASPE 2021",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio AFASPE 2021",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO-AFASPE-HGO-2021.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "CONVENIO CRESCA 2021",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "CONVENIO CRESCA 2021",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO CRESCA 2021.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio AFASPE 2020",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio AFASPE 2020",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Convenio AFASPE 2020.zip"
            }
         ]
    },
    {
        "tramite_loc" : "2020",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Anexo_ 6CAF_CAE_ Partidas_ de_ Gasto_ autorizadas_ 2020(14-05-2020)",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Anexo_6CAF_CAE_Partidas_de_Gasto_autorizadas_2020 (14-05-2020).pdf"
            }
         ]
    },
    {
        "tramite_loc" : "2020",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Anexo_ 6CAF_ CAE_ Partidas_ de_ Gasto_ autorizadas_ 2020(14-08-2020)",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Anexo_6CAF_CAE_Partidas_de_Gasto_autorizadas_2020 (14-08-2020).pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Programa regularización y vigilancia de establecimientos y servicios de atención médica G005.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio especifico de colaboración No. DGCES-CETR-HGO-G005-2020 en materia de transferencia de recursos presupuestarios federales con el carácter de subsidios",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/FIRMADO CONVENIO G005 2020.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Atención a la salud y medicamentos gratuitos para la población sin seguridad social laboral para el ejercicio fiscal 2020",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio de colaboración en materia de transferencia de recursos presupuestarios federales con el carácter de subsidios para el desarrollo de acciones correspondientes a la vertiente 2 del programa",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Convenio CTR-U013-2020-V.2-HGO-13.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Programa Seguro Médico Siglo XXI (PSMS XXI)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio de colaboración en materia de transferencia de recursos para la ejecución del programa seguro médico siglo XXI",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO PSMS XXI 2020.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio Específico en Materia de Ministración de Subsidios para el Fortalecimiento de Acciones de Salud Pública de las Entidades Federativas.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "AFASPE 2019",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/AFASPE 2019.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio específico de colaboración en materia de transferencia de recursos presupuestarios federales con el caracter de subsidios.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio específico de colaboración para la operación del programa: Atención a la Salud y Medicamentos Gratuitos para la Población sin Seguridad Social Laboral",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/Convenio PU013 Hidalgo 2019.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio de colaboración Regulación y Vigilancia de establecimientos y Servicios de Atención Médica GOO5.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio especifico de colaboración No. DGCES-CETR-HGO-G005 del programa de Regulación y Vigilancia de establecimientos y Servicios de Atención Médica GOO5. 2019",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO G005 COPIA CERTIFICADA.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Mejorar la calidad del diagnóstico oportuno de cáncer de mama en la región Tulancingo y Otomí-Tepehua en las mujeres de 40 a 69 de años.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Calidad en la Atención Médica PROCAM 2018",
                "transparencia_item_url" : "./Pcam/Pcam"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio de colaboración para la ejecución del programa nacional para la reducción de la mortalidad por infarto agudo al miocardio.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio de colaboración para la ejecución del programa nacional para la reducción de la mortalidad por infarto agudo al miocardio",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/convenio de colaboracion miocardio.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio de colaboración Regulación y Vigilancia de establecimientos y Servicios de Atención Médica GOO5.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio especifico de colaboración No. DGCES-CETR-HGO-G005 del programa de Regulación y Vigilancia de establecimientos y Servicios de Atención Médica GOO5. 2018",
                "transparencia_item_url" : "../../contenido/transparencia/convenios/CONVENIO G005 FINAL FIRMADO.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio de Transferencia de Recursos FAM 2018",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio DGPLADES-FAM-CECTR-HGO-01/18",
                "transparencia_item_url" : "../../contenido/transparencia/sps/DGPLADES-FAM-CECTR-HGO-01-18.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Convenio de colaboración Regulación y Vigilancia de establecimientos y Servicios de Atención Médica GOO5.",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Convenio especifico de colaboración No. DGCES-CETR-HGO-G005-17 del programa de Regulación y Vigilancia de establecimientos y Servicios de Atención Médica GOO5. 2017",
                "transparencia_item_url" : "../../contenido/transparencia/sps/Convenio DGCES-CETR-HGO-G005-17.pdf"
            }
         ]
    }        
]

